module.exports = __webpack_public_path__ + "media/images/rolando-signature-bc8fbe5db1f8186822e1268345bd3fe9.jpeg";